<div style="padding: 25px">
  <div class="flex flex-col xl:flex-row gap-2 justify-between">
    <span class="flex justify-start items-center text-black font-black uppercase"> Lista de Filiais </span>
    <div class="flex justify-start lg:justify-end flex-wrap gap-2">
      <div>
        <select
          class="w-60 p-2 form-select form-select-lg mr-5 text-white font-medium btn--primary"
          aria-label="Ordenação"
          [formControl]="ordenarControl"
        >
          <option disabled>Ordenar</option>
          <option *ngFor="let order of opcoesOrdenacao" [value]="order.value">{{ order.label }}</option>
        </select>
      </div>

      <div *ngIf="!companyId">
        <select
          class="w-60 p-2 form-select form-select-lg text-white font-medium btn--primary"
          aria-label="Filtrar por empresa"
          [formControl]="companyControl"
        >
          <option [ngValue]="null">Todas empresas</option>
          <option *ngFor="let company of companies" [ngValue]="company.id">{{ company.name }}</option>
        </select>
      </div>

      <app-status-filter [formControl]="statusControl"></app-status-filter>

      <div>
        <input
          [formControl]="acaoInput"
          type="text"
          class="form-input w-80"
          placeholder="Pesquise por Nome, Código ou CNPJ"
        />
      </div>
      <div class="flex justify-between">
        <button title="Filtrar Filiais" (click)="filtrarFilial()" class="px-5 min-w-max btn btn--secondary h-35 ml-5">
          <img class="w-6 h-6" src="./assets/icons/search_white.svg" alt="search" />
        </button>
        <button
          title="Limpar Filtro"
          (click)="limparFiltros()"
          class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine"
        >
          <img class="w-6 h-6" src="./assets/icons/backspace_white.svg" alt="search" />
        </button>
        <button
          *isAllowed="[ERoleAdminString.Admin, 'subsidiary.export']"
          title="Download Excel com Filiais"
          class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine"
          (click)="downloadExcel()"
        >
          <img class="w-6 h-6" src="./assets/icons/download.svg" alt="Download Excel" />
        </button>
      </div>
    </div>
  </div>

  <app-filiais-list
    [filiais]="filiais"
    [dadosPaginacao]="dadosPaginacao"
    (mudouPagina)="mudouPagina($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
    (recarregarListagem)="carregarFiliais()"
    (editarFilial)="editarFilial($event)"
  >
  </app-filiais-list>

  <app-add-new-filiais (recarregarListagem)="carregarFiliais()" [companyId]="companyId"></app-add-new-filiais>
  <app-filiais-edit
    *ngIf="editarFilialId !== undefined"
    [filialId]="editarFilialId"
    (cancelarEdit)="editarFilialId = undefined"
    (finalizarEdit)="editarFilialId = undefined"
    (recarregarListagem)="carregarFiliais()"
  ></app-filiais-edit>

  <hr class="my-8" />
</div>
